import homepage from './homepage';
import document from './document';
export default {
    homepage,
    document,
};
